/**
 * Created by Administrator on 2019/1/2.
 */
import examDetailRouteChild from "@/routes/path/Child/examDetailRouteChild";
const routes = [
  // {
  //   path: "/",
  //   redirect: "/examlist"
  // },
  {
    path: "/examlist",
    name: "examlist",
    component: resolve => require(["@/views/ExamManage/examList.vue"], resolve),
    meta: {
      title: "南昊AI教学提分平台",
      auth: 0,
      keepAlive: true,
      isBack: false
    }
  },
  {
    path: "/examdetailindex",
    name: "examdetailindex",
    component: resolve => require(["@/views/ExamManage/ExamDetail/index.vue"], resolve),
    // children: examDetailRouteChild,
    meta: {
      title: "南昊AI教学提分平台",
      auth: 0,
      keepAlive: false
    }
  },
  {
    path: "/situationanalysisindex",
    name: "situationanalysisindex",
    component: resolve => require(["@/views/ExamManage/ExamDetail/SituationAnalysisIndex.vue"], resolve),
    // children: examDetailRouteChild,
    meta: {
      title: "南昊AI教学提分平台",
      auth: 0,
      keepAlive: false
    }
  },
  {
    path: "/moresubjectmixedread",
    name: "moresubjectmixedread",
    component: resolve => require(["@/views/ExamManage/ExamDetail/MoreSubjectMixedRead/index.vue"], resolve),
    // children: examDetailRouteChild,
    meta: {
      title: "南昊AI教学提分平台",
      auth: 0,
      keepAlive: false
    }
  },
];
export default routes;
